import { createFileRoute } from '@tanstack/react-router'
import { SupplierPaperboardEditor } from './-SupplierPaperboardEditor'

export const Route = createFileRoute('/packaging/suppliers-paperboard/$id')({
  component: SupplierEditPage,
})

function SupplierEditPage() {
  const { id } = Route.useParams()
  return <SupplierPaperboardEditor id={id} />
}
